import { AuthContext } from '@justgiving/auth-react';
import config from '../config';
import { useContext } from 'react';

export const useSsoRedirection = () => {
  const auth = useContext(AuthContext);

  if (!auth || auth.isCharity()) {
    return;
  }

  if (!auth.isUserLoggedIn()) {
    return generateRedirectionUrl('set_profile');
  }

  // Checks if user has charity permissions, even if these are not in their "ACTIVE_GROUPS" cookie
  const hasCharityPermissions = (() => {
    const permissions = auth?.getAccessToken()?.permissions;
    if (!permissions) {
      return false;
    }
    for (let i = 0; i < permissions.length; i++) {
      if (permissions[i].indexOf('charity') > -1) {
        return true;
      }
    }
    return false;
  })();

  if (hasCharityPermissions) {
    return generateRedirectionUrl('set_profile');
  } else {
    return generateRedirectionUrl('no_permission_charity');
  }
};

export const generateRedirectionUrl = (actionType: string) => {
  const encodedOptions = Buffer.from(
    JSON.stringify({
      EmailLabel: 'Work Email Address',
      SignUpUrl: `https://www.justgiving.com/charities/onboarding`,
      IsConsumer: false,
      EnableFacebook: false,
      EnableTwitch: false,
    }),
  ).toString('base64');

  return `${
    config.SSO_URL
  }?context=charity&actionType=${actionType}&returnUrl=${encodeURIComponent(
    document.location.href,
  )}&encodedOptions=${encodedOptions}`;
};
